import { ChargerModelEnum } from '../enums/ChargerModelEnum';

export const CHARGER_MODELS = Object.values(ChargerModelEnum);

export const OURA_RING_4_CHARGING_CASE_HANDLE = 'charger-case-oura-4';

export const STELO_DEXCOM_CGM_HANDLE = 'stelo-dexcom-cgm';
